/**
 * About — "Where luxury aviation meets genuine hospitality" (TZ section 4): the logo strip scrolls in a loop.
 * Logic: utils/logo-marquee.js.
 */
import {initLogoMarquee} from "../../utils/logo-marquee.js";

const SPEED = 25; // px per second — lower = slower

export const abHospitality = () => {
    return new Promise((resolve) => {
        document.querySelectorAll('.ab-hospitality__logos').forEach((strip) => initLogoMarquee(strip, {
            track: '.ab-hospitality__logos-track',
            group: '.ab-hospitality__logos-group',
            speed: SPEED,
        }));
        resolve();
    });
};
